import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import { ZonesPage, BranchesPage, DepartmentsPage, DesignationsPage, UsersPage } from "@/pages/Masters";
import AuditLogPage from "@/pages/AuditLogPage";
import ImportPage from "@/pages/ImportPage";
import SanctionMaster from "@/pages/SanctionMaster";
import ScrRegister from "@/pages/ScrRegister";
import ScrNew from "@/pages/ScrNew";
import ScrInbox from "@/pages/ScrInbox";
import Employees from "@/pages/Employees";
import Requisitions from "@/pages/Requisitions";
import MrfNew from "@/pages/MrfNew";
import MrfInbox from "@/pages/MrfInbox";
import MrfDetail from "@/pages/MrfDetail";
import MrfConfig from "@/pages/MrfConfig";
import WaApprove from "@/pages/WaApprove";
import Candidates from "@/pages/Candidates";
import PipelineBoard from "@/pages/PipelineBoard";
import Interviews from "@/pages/Interviews";
import FeedbackForm from "@/pages/FeedbackForm";
import Offers from "@/pages/Offers";
import JoiningTracker from "@/pages/JoiningTracker";
import Onboarding from "@/pages/Onboarding";
import ReportSchedules from "@/pages/ReportSchedules";

function Protected({ children, resource, action = "read" }) {
  const { user, loading, can } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F6F8]">
        <div className="font-serif text-xl text-[#0E2240]">HIRE<span className="text-[#BF9B30]">360</span></div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (resource && !can(resource, action)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={!loading && user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/zones" element={<Protected resource="masters"><ZonesPage /></Protected>} />
      <Route path="/branches" element={<Protected resource="masters"><BranchesPage /></Protected>} />
      <Route path="/departments" element={<Protected resource="masters"><DepartmentsPage /></Protected>} />
      <Route path="/designations" element={<Protected resource="masters"><DesignationsPage /></Protected>} />
      <Route path="/users" element={<Protected resource="users"><UsersPage /></Protected>} />
      <Route path="/audit" element={<Protected resource="audit"><AuditLogPage /></Protected>} />
      <Route path="/import" element={<Protected resource="import" action="write"><ImportPage /></Protected>} />
      <Route path="/sanctions" element={<Protected resource="sanctions"><SanctionMaster /></Protected>} />
      <Route path="/scr" element={<Protected resource="scr"><ScrRegister /></Protected>} />
      <Route path="/scr/new" element={<Protected resource="scr" action="create"><ScrNew /></Protected>} />
      <Route path="/scr/inbox" element={<Protected resource="scr" action="approve"><ScrInbox /></Protected>} />
      <Route path="/employees" element={<Protected resource="employees"><Employees /></Protected>} />
      <Route path="/requisitions" element={<Protected resource="requisitions"><Requisitions /></Protected>} />
      <Route path="/requisitions/new" element={<Protected resource="requisitions" action="write"><MrfNew /></Protected>} />
      <Route path="/requisitions/inbox" element={<Protected resource="requisitions" action="approve"><MrfInbox /></Protected>} />
      <Route path="/requisitions/config" element={<Protected resource="mrf_config"><MrfConfig /></Protected>} />
      <Route path="/requisitions/:reqId" element={<Protected resource="requisitions"><MrfDetail /></Protected>} />
      <Route path="/candidates" element={<Protected resource="candidates"><Candidates /></Protected>} />
      <Route path="/pipeline" element={<Protected resource="pipeline"><PipelineBoard /></Protected>} />
      <Route path="/interviews" element={<Protected resource="pipeline"><Interviews /></Protected>} />
      <Route path="/feedback/:interviewId" element={<Protected resource="pipeline"><FeedbackForm /></Protected>} />
      <Route path="/offers" element={<Protected resource="offers"><Offers /></Protected>} />
      <Route path="/joining" element={<Protected resource="pipeline"><JoiningTracker /></Protected>} />
      <Route path="/onboarding" element={<Protected resource="onboarding"><Onboarding /></Protected>} />
      <Route path="/reports" element={<Protected resource="reports"><ReportSchedules /></Protected>} />
      <Route path="/approve/:reqId" element={<WaApprove />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
